import React from 'react'
import { connect } from 'react-redux'
import { isString, isNumber, sortBy, values } from 'lodash'
import { Glyphicon, Table, FormControl } from 'react-bootstrap'
import { createSelector } from 'reselect'

import { getSuppliers } from '../../selectors'

import Button from '../../components/Button'
import { getText } from '../../lib/text'
import { randstr } from '../../../lib/Tools'

const CommissionsList = ({ trip, onBookingChange, onListChange, suppliersList }) => (
  <Table bordered condensed striped style={{ marginTop: 15, maxWidth: 500 }}>
    <thead>
      <tr>
        <th>{getText("Nombre")}</th>
        <th>{getText("Proveedor")}</th>
        <th>{"€"}</th>
        <th><Glyphicon glyph="remove" /></th>
      </tr>
    </thead>
    <tbody>
      {
        [ 
          { name: "Comisión Booking", value: trip.commission }, 
          ...trip.commissions 
        ]
          .map((c, i) => (
            <tr key={c.key || c.name + i}>
              <td>{c.name || " - "}</td>
              <td style={{ maxWidth: 120 }}>
                {
                  i > 0 && (
                    <FormControl 
                      componentClass="select"
                      bsSize="xsmall"
                      style={{ maxWidth: 120 }}
                      value={c.supplierId || null}
                      onChange={evt => {
                        const supplierId = evt.target.value || null
                        onListChange(trip.commissions.map((x, j) => (
                          j != (i - 1) ? x : { ...x, supplierId }
                        )))
                      }}
                    >
                      <option value={""} >{`${getText("Sin proveedor")}`}</option>
                      { 
                        suppliersList
                        .map(s => <option key={s._id} value={s._id}>{s.name}</option>) 
                      }
                    </FormControl>
                  )
                }
              </td>
              <td>
                <FormControl
                  style={{ display: "inline", width: 80, textAlign: "right" }}
                  bsSize="small"
                  value={i == 0 ? trip.commission : trip.commissions[i-1].value}
                  type="number"
                  onChange={evt => {
                    const value = parseFloat(evt.target.value)
                    if (isNumber(value)) {
                      if (i == 0) onBookingChange(value)
                      else onListChange(trip.commissions.map((x, j) => (
                        j != (i - 1) ? x : { ...x, value }
                      )))
                    }
                  }}
                />
              </td>
              <td>
                {
                  i > 0 && (
                    <Button 
                      glyph="remove"
                      bsSize="xsmall"
                      onClick={() => onListChange(trip.commissions.filter((x, j) => j != (i - 1)))}
                    />
                  )
                }
              </td>
            </tr>
          ))
      }
      <tr>
        <td colSpan="4">
          <Button 
            glyph="plus"
            bsSize="xsmall"
            onClick={() => {
              const name = prompt(getText("Nombre de la comisión/descuento (opcional)"))
              if (isString(name)) {
                onListChange(trip.commissions.concat({ name, value: 0, supplierId: null, key: randstr() }))
              }
            }}
          >
            {getText("Nuevo")}
          </Button>
        </td>
      </tr>
    </tbody>
  </Table>
)

const getSuppliersList = createSelector(
  [getSuppliers], 
  S => sortBy(values(S), o => o.name && o.name.toLowerCase()) 
)

const mapStateToProps = state => ({
  suppliersList: getSuppliersList(state), 
})

export default connect(mapStateToProps)(CommissionsList)
